import { useSelector } from 'react-redux';
import carConfigurationSelectors from '../store/selectors/carConfigurationSelectors';
import useUrlPersistedCustomisation from './useUrlPersistedCustomisation';
import useProcessedAccessoriesAndPacks from './customiseData/useProcessedAccessoriesAndPacks';
import useVariantDetailsChange from './customiseData/useVariantDetailsChange';
import useCustomiseOptions from './customiseData/useCustomiseOptions';
import useLoadInitialCar from './customiseData/useLoadInitialCar';
import useChangedCarDetails from './customiseData/useChangedCarDetails';
import useConfigureActions from './customiseData/useConfigureActions';

const useCustomisedConfiguration = () => {
  const storeCustomisedCar = useSelector(carConfigurationSelectors.getCustomisedCar);
  const { configureBasket } = useConfigureActions();

  useUrlPersistedCustomisation(storeCustomisedCar);
  useLoadInitialCar(configureBasket);
  useChangedCarDetails(configureBasket);
  useVariantDetailsChange();
  useCustomiseOptions();
  useProcessedAccessoriesAndPacks(storeCustomisedCar);
};

export default useCustomisedConfiguration;
